import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MomentPipe } from 'src/app/moment-pipe.pipe';
import { AlertService } from 'src/app/services/alert-service.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FormChangeService } from 'src/app/services/form-change.service';
import { ParkingService } from 'src/app/services/parking.service';
import { CommerceService } from '../commerce.service';

@Component({
  selector: 'app-update-commerce',
  templateUrl: './update-commerce.component.html',
  styleUrls: ['./update-commerce.component.scss']
})
export class UpdateCommerceComponent  implements OnInit {
  commercesCreateForm: FormGroup;
  keys = Object.keys;
  degicods;
  selectedCustomer: string = null;
  selectedCivilite: string = null;
  commerceToSave: any;
  emailInvalid: boolean;
  firstContact;
  lastContact;
  addressObject;
  initialAdress;
  genres = [
    {id: 1, code:'MADAME', name:'Madame'},
    {id: 2, code:'MADEMOISELLE', name:'Mademoiselle'},
    {id: 3, code:'MONSIEUR', name: 'Monsieur'}
  ];
  commerce : any;
  ;
  constructor(
    private fb: FormBuilder,
    private digicodService: ParkingService,
    protected alertService: AlertService,
    private commerceServ: CommerceService,
    public authenSer: AuthenticationService,
    public activeModal: NgbActiveModal,
    private formService: FormChangeService,
    private route: Router,
    private momentPipe: MomentPipe
  ) {
    this.commerce = this.route.getCurrentNavigation().extras.state?this.route.getCurrentNavigation().extras.state.commerce:null;
  }

  ngOnInit(): void {
    this.initForm();
    if(this.commerce){
      this.updateForm(this.commerce);

    }
  }

  initForm() {
    this.commercesCreateForm = this.fb.group({
      adress :new FormControl(""),
      city: new FormControl(""),
      longitude: [],
      id: [],
      latitude: [],
      civilite:new FormControl(""),
      companyName:new FormControl(""),
      contactName:new FormControl(""),
      contactPosition:new FormControl(""),
      cp:new FormControl(""),
      email:new FormControl(""),
      tel1: new FormControl(""),
      tel2:new FormControl(""),
      siret:new FormControl(""),
    });

  }
  updateForm(commerce: any): void {
    this.initialAdress = commerce.adress, commerce.city;
    this.commercesCreateForm.patchValue({

      civilite: commerce.civilite,
      latitude: commerce.latitude,
      longitude: commerce.longitude,
      companyName: commerce.companyName,
      contactName: commerce.contactName,
      contactPosition: commerce.contactPosition,
      email: commerce.email,
      tel1: commerce.tel1,
      tel2: commerce.tel2,
      siret: commerce.siret,
    });

  }
  private createFromForm(): any {

    let tmp = {
      id: this.commerce.id,
      adress : this.commerce.adress,
      cp: this.commerce.cp,
      city: this.commerce.city,

      civilite: this.commercesCreateForm.get(["civilite"]).value?this.commercesCreateForm.get(["civilite"]).value:null,
      companyName: this.commercesCreateForm.get(["companyName"]).value?this.commercesCreateForm.get(["companyName"]).value:null,
      contactName: this.commercesCreateForm.get(["contactName"]).value?this.commercesCreateForm.get(["contactName"]).value:null,
      contactPosition: this.commercesCreateForm.get(["contactPosition"]).value?this.commercesCreateForm.get(["contactPosition"]).value:null,

      email: this.commercesCreateForm.get(["email"]).value?this.commercesCreateForm.get(["email"]).value:null,
      tel1: this.commercesCreateForm.get(["tel1"]).value?this.commercesCreateForm.get(["tel1"]).value:null,
      tel2: this.commercesCreateForm.get(["tel2"]).value?this.commercesCreateForm.get(["tel2"]).value:null,
      siret: this.commercesCreateForm.get(["siret"]).value?this.commercesCreateForm.get(["siret"]).value:null,
    };

    this.fillAdressElements(tmp);
    return tmp;
  }
  fillAdressElements(tmp){
    if(this.addressObject){
      this.addressObject.address_components.forEach(element => {
        let type = element.types[0];
        if("postal_code" == type){
          tmp['cp'] = element.long_name;
        }
        if("locality" == type){
          tmp['city'] = element.long_name;
        }
      });
      tmp['latitude'] = this.addressObject.geometry.location.lat();
      tmp['longitude'] = this.addressObject.geometry.location.lng();
      tmp['adress']  = this.addressObject.name;
    }
  }
  getAddress(place: any) {
    this.addressObject = place;
  }
  save(): void {
    this.commerceToSave = this.createFromForm();
    this.commerceServ
      .saveCommerce(this.commerceToSave)
      .subscribe(
        (data) => {
          this.alertService.success("Commerce Sauvegardé !", true);
          this.formService.raiseReloadCommersSearchRequestEvent();
          this.route.navigateByUrl("/commerces");
        },
        (error) => {
          console.log(error);
          this.alertService.error("Erreur dans le formulaire !", true);
        }
      );
  }
}
